/* CEREMONIES */
export const GET_BUDGETS_PERCENTAGE = "GET_BUDGETS_PERCENTAGE"
export const GET_BUDGETS_PERCENTAGE_SUCCESS = "GET_BUDGETS_PERCENTAGE_SUCCESS"
export const GET_BUDGETS_PERCENTAGE_FAIL = "GET_BUDGETS_PERCENTAGE_FAIL"

/* CEREMONIES PROFILE */
export const GET_BUDGET_PERCENTAGE_PROFILE = "GET_BUDGET_PERCENTAGE_PROFILE"
export const GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS = "GET_BUDGET_PERCENTAGE_PROFILE_SUCCESS"
export const GET_BUDGET_PERCENTAGE_PROFILE_FAIL = "GET_BUDGET_PERCENTAGE_PROFILE_FAIL"

/**
 * add BUDGET_PERCENTAGE
 */
 export const ADD_NEW_BUDGET_PERCENTAGE = "ADD_NEW_BUDGET_PERCENTAGE"
 export const ADD_BUDGET_PERCENTAGE_SUCCESS = "ADD_BUDGET_PERCENTAGE_SUCCESS"
 export const ADD_BUDGET_PERCENTAGE_FAIL = "ADD_BUDGET_PERCENTAGE_FAIL"

 /**
 * Edit BUDGET_PERCENTAGE
 */
export const UPDATE_BUDGET_PERCENTAGE = "UPDATE_BUDGET_PERCENTAGE"
export const UPDATE_BUDGET_PERCENTAGE_SUCCESS = "UPDATE_BUDGET_PERCENTAGE_SUCCESS"
export const UPDATE_BUDGET_PERCENTAGE_FAIL = "UPDATE_BUDGET_PERCENTAGE_FAIL"

/**
 * Delete BUDGET_PERCENTAGE
 */
export const DELETE_BUDGET_PERCENTAGE = "DELETE_BUDGET_PERCENTAGE"
export const DELETE_BUDGET_PERCENTAGE_SUCCESS = "DELETE_BUDGET_PERCENTAGE_SUCCESS"
export const DELETE_BUDGET_PERCENTAGE_FAIL = "DELETE_BUDGET_PERCENTAGE_FAIL"


